import React from 'react'
import styles from './button.module.scss'
import cls from 'classnames'
import BasicButton, { TButtonProps as TBasicButtonProps } from 'core/components/Button'

type TButtonProps = {
  type?: 'default' | 'primary' | 'secondary' | 'gray' | 'link' | 'rise' | 'fall'
  full?: boolean
  size?: 's' | 'm' | 'default' | 'l' // 暂定 s m default, 后续根据需求增加 xs xl l 等 s: 25 m 36 : default: 44 l: 48
  variant?: 'outline' // 按钮变体
  className?: string
} & TBasicButtonProps

export default function Button(props: TButtonProps) {
  const { type = 'default', size = 'default', ...restProps } = props
  return (
    <BasicButton
      {...restProps}
      buttonClassName={cls(styles.button, styles[`button-${type}`], styles[size], props.className || '', {
        [styles.full]: props.full ?? true,
        [styles['button-outline']]: props.variant === 'outline' || type === 'gray',
      })}
    />
  )
}
